"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bluePalette = void 0;
var tempusBlue = '#39ABD1';
var bluePalette = {
  royalBlue: '#0B5973',
  // pressed button
  ceruleanBlue: '#0C80A6',
  // hover on button/pressed within dropdown
  blue: tempusBlue,
  tempusBlue: tempusBlue,
  // tempus standard blue. Primary buttons, clickable elements and links
  seaBlue: '#88CDE3',
  powderBlue: '#C3E5F1',
  // disabled button
  robinBlue: '#E2F3F8',
  skyBlue: '#F5FBFC' // selected table row

};
exports.bluePalette = bluePalette;